const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        showModal: false,
    });
};

const initialState = setInitialState();

const optionsReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.SHOW_MODAL_CANCEL:
            return state.merge({
                showModal: true,
            });

        case actionTypes.HIDE_MODAL_CANCEL:
            return state.merge({
                showModal: false,
            });

        default:
            return state;
    }
};

module.exports = optionsReducer;
